<template>
    <div v-if="showCount" class="nature-time-count-ani"></div>
</template>

<script>
export default {
    name: 'NatureTime',
    computed: {
        natureTimeLimit() {
            return this.$store.state.report.natureTimeLimit;
        }
    },
    data() {
        return {
            showCount: false,
            countFunc: undefined,
        }
    },
    mounted() {
        this.$bus.on('updateDetailNatureTime', this.initTimeCountDown);
        this.$bus.on('clearDetailNatureTime', this.clearTimeCountDown);
    },
    destroyed() {
        this.$bus.off('updateDetailNatureTime', this.initTimeCountDown);
        this.$bus.off('clearDetailNatureTime', this.clearTimeCountDown);
    },
    methods: {
        initTimeCountDown() {
            var me = this,
                natureCharacterData = this.$store.state.report.natureCharacterData,
                natureTalentData = this.$store.state.report.natureTalentData,
                curSecond = this.natureTimeLimit;
            if(natureCharacterData.needpay == 0 && natureTalentData.needpay == 0) {
                return;
            }
            // console.error('initTimeCountDown------', curSecond, natureCharacterData.needpay, natureTalentData.needpay)
            this.showCount = (natureCharacterData.needpay == 1 || natureTalentData.needpay == 1) && curSecond > 0 ? true : false;
            this.countFunc = setTimeout(count, 1000)
            function count() {
                curSecond--;
                clearTimeout(me.countFunc);
                // console.error('curSecond------', curSecond)
                if(curSecond >= 0) {
                    me.$store.state.report.natureTimeLimit = curSecond;
                    me.countFunc = setTimeout(count, 1000);
                    me.showCount = (natureCharacterData.needpay == 1 || natureTalentData.needpay == 1) && curSecond > 0 ? true : false;
                }
            }
        },
        clearTimeCountDown() {
            clearTimeout(this.countFunc);
        }
    }
}
</script>